var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.774414,
    y: 0.833344,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 20.8333H10.6508C9.73908 20.8333 8.99999 20.1058 9 19.2083L9.00006 9.45834C9.00007 8.56088 9.73915 7.83334 10.6509 7.83334H18.0796C18.9913 7.83334 19.7304 8.56088 19.7304 9.45835V12.7084M11.8891 11.0834H16.8415M11.8891 13.5209H16.8415M11.8891 15.9584H14.3653M20.3677 14.9472L21.6958 16.2752M17.0476 19.5952L18.6583 19.2707C18.7438 19.2535 18.8223 19.2114 18.8839 19.1497L22.4895 15.5423C22.6623 15.3694 22.6622 15.089 22.4892 14.9162L21.7254 14.1533C21.5525 13.9806 21.2723 13.9807 21.0995 14.1536L17.4935 17.7613C17.432 17.8229 17.39 17.9012 17.3727 17.9866L17.0476 19.5952Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCircle);
export default __webpack_public_path__ + "static/media/report-circle.fdd695c3b672c1106f3ea84823ffeb8f.svg";
export { ForwardRef as ReactComponent };